import React from "react";
import { cn } from "@/utils";

type TextLabelVariant = "dark" | "light";

interface TextLabelProps extends React.HTMLProps<HTMLDivElement> {
  variant?: TextLabelVariant;
}

const TextLabel: React.FC<TextLabelProps> = ({
  className,
  children,
  variant = "dark",
  ...props
}) => {
  return (
    <div
      className={cn(
        "text-base px-3 py-[2px] max-w-max rounded-full",
        variant === "dark" && "bg-dark text-emerald-50",
        variant === "light" && "bg-emerald-50 text-dark",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default TextLabel;
